/**
 * AM.One API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OpenApiEndpointDto } from './openApiEndpointDto';


export interface ArtifactDto { 
    /**
     * Diskriminator, der angibt, welche der optionalen Felder in ArtifactDto befüllt sind. 
     */
    artifactKind: ArtifactDto.ArtifactKindEnum;
    /**
     * Der erkannte Typ eines technischen Artefakts (Diagrammquelle oder API-Spezifikation). 
     */
    artifactType: ArtifactDto.ArtifactTypeEnum;
    /**
     * Relativer Pfad der Artefaktdatei innerhalb des Konzeptordners.
     */
    sourcePath: string;
    /**
     * Relative URL zum Herunterladen des Artefakts.
     */
    downloadUrl?: string | null;
    /**
     * Data-URI (data:image/svg+xml;base64,...) des gerenderten Diagramms. Null, wenn das Diagramm nicht serverseitig gerendert wird oder das Rendering fehlgeschlagen ist (siehe renderError). 
     */
    renderedSvg?: string | null;
    /**
     * Fehlerbeschreibung, falls das serverseitige Rendering über Kroki fehlgeschlagen ist.
     */
    renderError?: string | null;
    /**
     * Mermaid-Quelldefinition für das clientseitige Rendering; für alle anderen Artefakttypen null.
     */
    sourceText?: string | null;
    /**
     * Titel der OpenAPI-Spezifikation (aus info.title).
     */
    title?: string | null;
    /**
     * Version der OpenAPI-Spezifikation (aus info.version).
     */
    version?: string | null;
    endpoints?: Array<OpenApiEndpointDto> | null;
}
export namespace ArtifactDto {
    export const ArtifactKindEnum = {
        Diagram: 'DIAGRAM',
        OpenApi: 'OPEN_API',
        Unknown: 'UNKNOWN'
    } as const;
    export type ArtifactKindEnum = typeof ArtifactKindEnum[keyof typeof ArtifactKindEnum];
    export const ArtifactTypeEnum = {
        OpenApi: 'OPEN_API',
        Dbml: 'DBML',
        Structurizr: 'STRUCTURIZR',
        Mermaid: 'MERMAID',
        PlantUml: 'PLANT_UML',
        Unknown: 'UNKNOWN'
    } as const;
    export type ArtifactTypeEnum = typeof ArtifactTypeEnum[keyof typeof ArtifactTypeEnum];
}


